import React, { useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const DEBOUNCE_MS = 300;

export default function ArtworkSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  // Synchronous initializer — reads q from URL once on mount, no flash
  const [value, setValue] = useState(searchParams.get('q') ?? '');
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const applySearch = (newValue: string) => {
    setSearchParams({ q: newValue, page: '1' });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (newValue === '') {
      // Immediate on clear — no debounce
      applySearch('');
    } else {
      debounceRef.current = setTimeout(() => applySearch(newValue), DEBOUNCE_MS);
    }
  };

  const handleClear = () => {
    setValue('');
    if (debounceRef.current) clearTimeout(debounceRef.current);
    applySearch('');
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      placeholder="Search by title..."
      size="small"
      fullWidth
      slotProps={{
        input: {
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClear} aria-label="clear search">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
}
